import { render, staticRenderFns } from "./MortgageDetails.vue?vue&type=template&id=74cdf891&scoped=true&"
import script from "./MortgageDetails.vue?vue&type=script&lang=js&"
export * from "./MortgageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cdf891",
  null
  
)

export default component.exports